import Link from "next/link";
import {
  Children,
  cloneElement,
  ComponentProps,
  isValidElement,
  ReactChild,
  ReactPortal,
} from "react";
import { cx } from "@linaria/core";
import { useRouter } from "next/router";

function getChildClassName(
  child:
    | boolean
    | Record<string, unknown>
    | ReactChild
    | ReactPortal
    | null
    | undefined
): string {
  if (!child || typeof child !== "object") {
    return "";
  }

  return "props" in child && typeof child.props.className === "string"
    ? child.props.className
    : "";
}

function ActiveLink({
  activeClassName = "active",
  href,
  children,
  ...linkProps
}: ComponentProps<typeof Link> & { activeClassName?: string }): JSX.Element {
  const router = useRouter();
  const child = Children.only(children);

  const className = cx(
    getChildClassName(child),
    (router.pathname === href || router.pathname.startsWith(`${href}/`)) &&
      activeClassName
  );

  return (
    <Link href={href} {...linkProps}>
      {isValidElement(child) ? cloneElement(child, { className }) : child}
    </Link>
  );
}

export default ActiveLink;
